import React from 'react';
import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { Scrollbars } from 'react-custom-scrollbars';
import SideNav from '../SideNav/SideNav';
import SideBottom from '../SideBottom/SideBottom';

import Chat from '../Chat/Chat';
import Refs from '../Refs/Refs';
import Profile from '../Profile/Profile';

export default class Sidebar extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: 'chat',
      opened: true,
    };
  }

  changeTab = (tab) => {
    this.setState({
      activeTab: tab,
      opened: true,
    });
  };

  toggle = () => {
    this.setState({
      opened: !this.state.opened,
    });
  };

  renderTab = (tab) => {
    const components = {
      chat: <Chat />,
      refs: <Refs />,
      cabinet: <Profile />,
    };

    return components[tab] ? components[tab] : null;
  };

  render() {
    const { activeTab } = this.state;

    const variants = {
      initial: { opacity: 0, x: -50 },
      enter: { opacity: 1, x: 0 },
      exit: { opacity: 0 },
    };

    return (
      <div
        className={classNames('sidebar', {
          opened: this.state.opened,
          closed: !this.state.opened,
        })}
      >
        <div className="sidebar__inner">
          <SideNav onChange={this.changeTab} activeTab={this.state.activeTab} />
          <Scrollbars style={{ height: '100%' }} hideTracksWhenNotNeeded={true}>
            <AnimatePresence exitBeforeEnter initial={false}>
              <motion.div
                variants={variants}
                initial="initial"
                animate="enter"
                exit="exit"
                key={activeTab}
                className="sidebar__content"
              >
                {activeTab === 'chat' && <Chat />}
                {activeTab === 'refs' && <Refs />}
                {activeTab === 'cabinet' && <Profile />}
              </motion.div>
            </AnimatePresence>
          </Scrollbars>
          <SideBottom toggleMenu={this.toggle} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Sidebar/Sidebar.jsx